export default {
  name: 'env',
  api: 'https://api.qa.reservationslab.com/backend/',
  backendUrl: 'https://api.qa.reservationslab.com/backend/',
  ospUrl: 'https://api.qa.onestopparking.com/',
  googleRecaptcha: '6LcQlIQlAAAAALtOLoiNZkUcdOJJycfJ1ZO68MkB',
  googleKey: 'AIzaSyBZt5tUvyXDjRE4A8h3u2SqhXeDUxqq7As',
  parkingOtaUrl: 'https://qa.reservationslab.com/'
}
